/* @flow */

import _ReportInputParams from './ReportInputParams';

export default _ReportInputParams;



// WEBPACK FOOTER //
// ./src/components/ReportInputParams/index.js